import { Controller } from "@hotwired/stimulus"
import pdfLogo from '../../images/icons/pdf-logo.svg'
import closeSvg from '../../images/icons/close-x.svg'

export default class extends Controller {
    static targets = ["input", "preview", "form"]

    connect() {
        // this.maxFileSize = 5 * 1024 * 1024;
        // this.maxFiles = 5;
        this.currentFiles = new DataTransfer();
        this.allowedTypes = ['application/pdf', 'image/jpeg', 'image/png']
    }

    openFileDialog(event) {
        event.preventDefault()
        this.inputTarget.click()
    }

    handleFileSelect() {
        const newFiles = Array.from(this.inputTarget.files)

        // TODO in case this is needed
        // if (this.currentFiles.files.length + newFiles.length > this.maxFiles) {
        //     alert(`Galimų įkelti priedų skaičius: ${this.maxFiles}.`)
        //     this.inputTarget.value = ''
        //     return
        // }

        for (let file of newFiles) {
            if (!this.allowedTypes.includes(file.type)) {
                alert(`Priedas ${file.name} yra neleistinas. Tik PDF, JPG ir PNG priedų tipai yra leidžami.`)
                this.inputTarget.value = ''
                return
            }

            // TODO in case this is needed
            // if (file.size > this.maxFileSize) {
            //     alert(`Priedo ${file.name} dydis per didelis. Didžiausias leistinas dydis 10MB.`)
            //     this.inputTarget.value = ''
            //     return
            // }

            this.currentFiles.items.add(file)
        }

        this.updateFileList()
    }

    updateFileList() {
        this.previewTarget.innerHTML = '';

        for (let file of this.currentFiles.files) {
            this.createFilePreview(file);
        }

        if (this.currentFiles.files.length === 0) {
            this.previewTarget.classList.add("d-none");
        } else {
            this.previewTarget.classList.remove("d-none");
        }

        this.inputTarget.files = this.currentFiles.files;
    }

    createFilePreview(file) {
        const filePreview = document.createElement('div')
        filePreview.className = 'file-preview-item'

        const fileInfo = document.createElement('div')
        fileInfo.className = 'file-info'

        if (file.type === 'application/pdf') {
            fileInfo.innerHTML = `
              <img src="${pdfLogo}" alt="PDF" class="file-icon">
              <span>${file.name}</span>
            `
        } else {
            const img = document.createElement('img')
            img.className = 'file-thumbnail'
            img.alt = file.name

            const span = document.createElement('span')
            span.textContent = file.name

            fileInfo.appendChild(img)
            fileInfo.appendChild(span)

            const reader = new FileReader()
            reader.onload = (e) => {
                img.src = e.target.result
            }
            reader.readAsDataURL(file)
        }

        const removeButton = document.createElement('button')
        removeButton.className = 'btn'
        removeButton.style = 'fill: red;'
        removeButton.setAttribute('data-action', 'click->file-upload#removeFile')
        removeButton.setAttribute('data-file-name', file.name)
        removeButton.setAttribute('aria-label', 'Remove file')

        const imgElement = document.createElement('img')
        imgElement.src = closeSvg
        imgElement.alt = 'Remove'

        removeButton.appendChild(imgElement)

        filePreview.appendChild(fileInfo)
        filePreview.appendChild(removeButton)
        this.previewTarget.appendChild(filePreview)
    }

    removeFile(event) {
        const fileName = event.currentTarget.getAttribute('data-file-name')
        const newDataTransfer = new DataTransfer()
        for (let f of this.currentFiles.files) {
            if (f.name !== fileName) newDataTransfer.items.add(f)
        }
        this.currentFiles = newDataTransfer
        this.updateFileList()
    }
}
